/*eslint unicode-bom: ["error", "always"]*/
import styles from "./access.module.css";
import React from 'react';
import Spacer from "components/layout/Spacer";
import { NavLink } from 'react-router';

function NotFound() {

    return (
        <div className={styles.noAccess}>
            <div className={styles.noAccessTitle}>Oops...!</div>
            <div>
                <p>
                    Du har navigert til en side som ikke finnes.
                </p>
            </div>
            <Spacer />
            <div className="k-text-center">
                Klikk <NavLink to="/">her</NavLink>  for å gå navigere til forsiden.
            </div>
        </div>
    );
}

export default NotFound;
